import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes, youtubeUrlConstants } from "./YouTubeManagementReducer";

export function getYouTubeList(data, page, limit, type, isRedirected) {
  // console.log("yt data", data);
  // console.log(getState().youtubeManagement.redirected);
  const redirectedState = getState().youtubeManagement.redirected;
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_YOUTUBE_LIST_PENDING,
      payload: {
        getYouTubeListPending: true,
        getYouTubeListSuccess: false,
        getYouTubeListError: null,
      },
    });
    dispatch(showLoader());

    const dynamicUrl = type ? type : "videosByDailyCron";

    Api.post(
      `youtube/fetchVideoList/${dynamicUrl}?page=${page}&limit=${limit}`,
      data
    )
      .then((response) => {
        // console.log(response);
        const payloadVideosByDailyCron = {
          getYouTubeListPending: false,
          getYouTubeListSuccess: true,
          getYouTubeListError: null,
          youtubeList: response.data,
          redirected: isRedirected,
          currentPage: page,
          currentLimit: limit,
        };

        const payloadVideosByUrl = {
          getYouTubeListPending: false,
          getYouTubeListSuccess: true,
          getYouTubeListError: null,
          youtubeList: response.data,
          redirected: isRedirected,
          currentPageVideoByUrl: page,
          currentLimitVideoByUrl: limit,
        };

        const dynamicPayload =
          type !== "videosByDailyCron"
            ? payloadVideosByUrl
            : payloadVideosByDailyCron;

        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_YOUTUBE_LIST_SUCCESS,
          payload: dynamicPayload,
        });
        const searchFilterData = {
          titleSearch: data?.searchString || "",
          statusSearch: data?.status || "",
          languageSearch: data?.languageId || "",
          channelSearch: data?.channelId || "",
        };
        if (type === "videosByDailyCron") {
          dispatch(setSearchFilters(searchFilterData));
        } else {
          dispatch(setSearchFiltersForVideosByUrl(searchFilterData));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_YOUTUBE_LIST_ERROR,
          payload: {
            getYouTubeListPending: false,
            getYouTubeListSuccess: false,
            getYouTubeListError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch youtube data",
          })
        );
      });
  };
}

export function resetRedirected() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_REDIRECTED_STATE,
      payload: {
        redirected: false,
      },
    });
  };
}

export function resetPageAndLimit() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_PAGE_AND_LIMIT,
      payload: {
        currentPage: 1,
        currentLimit: 10,
        currentPageVideoByUrl: 1,
        currentLimitVideoByUrl: 10,
      },
    });
  };
}

export function setSearchFilters(data) {
  const { titleSearch, statusSearch, languageSearch, channelSearch } = data;
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SEARCH_FILTERS,
      payload: {
        titleSearch: titleSearch,
        statusSearch: statusSearch,
        languageSearch: languageSearch,
        channelSearch: channelSearch,
      },
    });
  };
}

export function resetSearchFilters() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SET_SEARCH_FILTERS,
      payload: {
        titleSearch: "",
        statusSearch: "",
        languageSearch: "",
        channelSearch: "",
      },
    });
  };
}

export function setSearchFiltersForVideosByUrl(data) {
  const { titleSearch, statusSearch, languageSearch, channelSearch } = data;
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL,
      payload: {
        videosByUrlTitleSearch: titleSearch,
        videosByUrlStatusSearch: statusSearch,
        videosByUrlLanguageSearch: languageSearch,
        videosByUrlChannelSearch: channelSearch,
      },
    });
  };
}

export function resetSearchFilterForVideosByUrl() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SEARCH_FILTERS_FOR_VIDEOS_BY_URL,
      payload: {
        videosByUrlTitleSearch: "",
        videosByUrlStatusSearch: "",
        videosByUrlLanguageSearch: "",
        videosByUrlChannelSearch: "",
      },
    });
  };
}

export function setActiveNavigationTab(activeTab) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_ACTIVE_NAVIGATION_TAB,
      payload: {
        activeNavTab: activeTab,
      },
    });
  };
}

export function resetActiveNavigationTab() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_ACTIVE_NAVIGATION_TAB,
      payload: {
        activeNavTab: youtubeUrlConstants?.YOUTUBE_VIDEOS_BY_DAILY_CRON,
        rowTags: [],
      },
    });
  };
}

export function setUpdatedRowTags(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_UPDATED_ROW_TAGS,
      payload: {
        rowTags: data,
      },
    });
  };
}

//resets rowTags array
export function resetRowTags() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_UPDATED_ROW_TAGS,
      payload: {
        rowTags: [],
      },
    });
  };
}

export function setUpdatedRowCategory(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_UPDATED_ROW_CATEGORY,
      payload: {
        rowCategory: data,
      },
    });
  };
}

export function resetRowCategory() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_UPDATED_ROW_CATEGORY,
      payload: {
        rowCategory: [],
      },
    });
  };
}

export function setShowSelection() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SHOW_SELECTION,
      payload: {
        showSelection: true,
      },
    });
  };
}

export function resetShowSelection() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SHOW_SELECTION,
      payload: {
        showSelection: false,
      },
    });
  };
}

export function setNavigatingToOtherPageWarningModal(data, link) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_NAVIGATING_TO_OTHER_PAGE,
      payload: {
        showWarningForRowTagsWhenNavigating: data,
        redirectingLink: link,
      },
    });
  };
}

export function setNavigatingToOtherTabWarningModal(link) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_NAVIGATING_TO_OTHER_TAB,
      payload: {
        // showWarningForRowTagsWhenNavigating: data,
        redirectingTab: link,
      },
    });
  };
}

export function resetNavigatingToOtherPageWarningModal() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_NAVIGATING_TO_OTHER_PAGE,
      payload: {
        showWarningForRowTagsWhenNavigating: false,
        redirectingLink: "",
        redirectingTab: "",
      },
    });
  };
}

export function setSelectedMultipleRows(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SELECTED_MULTIPLE_ROWS,
      payload: {
        selectedMultipleRowVideo: data,
      },
    });
  };
}

export function resetSelectedMultipleRows() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SELECTED_MULTIPLE_ROWS,
      payload: {
        selectedMultipleRowVideo: [],
      },
    });
  };
}

export function getYouTubeVideoById(param, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_YOUTUBE_VIDEO_BY_ID_PENDING,
      payload: {
        getYouTubeVideoByIdPending: true,
        getYouTubeVideoByIdSuccess: false,
        getYouTubeVideoByIdError: null,
      },
    });
    dispatch(showLoader());

    Api.get(`youtube/getVideoById/${param}`)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_YOUTUBE_VIDEO_BY_ID_SUCCESS,
          payload: {
            getYouTubeVideoByIdPending: false,
            getYouTubeVideoByIdSuccess: true,
            getYouTubeVideoByIdError: null,
            youtubeList: response.data,
          },
        });
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_YOUTUBE_VIDEO_BY_ID_ERROR,
          payload: {
            getYouTubeVideoByIdPending: false,
            getYouTubeVideoByIdSuccess: false,
            getYouTubeVideoByIdError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch youtube data",
          })
        );
      });
  };
}

export function addYouTubePublished(id, data, page, limit, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_YOUTUBE_PUBLISHED_PENDING,
      payload: {
        addYouTubePublishedPending: true,
        addYouTubePublishedSuccess: false,
        addYouTubePublishedError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`youtube/publishedVideos/${id}/youtube`, data)
      .then((response) => {
        // if (response.message === "Video published successfully") {
        dispatch(
          showAlert({
            isOpen: true,
            title: "success",
            type: "success",
            msg: response.message,
          })
        );
        // }
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_YOUTUBE_PUBLISHED_SUCCESS,
          payload: {
            addYouTubePublishedPending: false,
            addYouTubePublishedSuccess: true,
            addYouTubePublishedError: null,
          },
        });
        // const youtubeData = {};
        // dispatch(getYouTubeList(youtubeData, page, limit));
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_YOUTUBE_PUBLISHED_ERROR,
          payload: {
            addYouTubePublishedPending: false,
            addYouTubePublishedSuccess: false,
            addYouTubePublishedError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function uploadYoutubeThumbnail(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPLOAD_THUMBNAIL_PENDING,
      payload: {
        uploadThumbnailPending: true,
        uploadThumbnailSuccess: false,
        uploadThumbnailError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`youtube/uploadThumbnails`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.UPLOAD_THUMBNAIL_SUCCESS,
          payload: {
            uploadThumbnailPending: false,
            uploadThumbnailSuccess: true,
            uploadThumbnailError: null,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.UPLOAD_THUMBNAIL_ERROR,
          payload: {
            uploadThumbnailPending: false,
            uploadThumbnailSuccess: false,
            uploadThumbnailError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function addMultipleYouTubeVideoPublished(data, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_MULTIPLE_PUBLISH_PENDING,
      payload: {
        addMultiplePublishPending: true,
        addMultiplePublishSuccess: false,
        addMultiplePublishError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`youtube/publishedMultipleVideos`, data)
      .then((response) => {
        if (response.message === "Successfully published multiple videos") {
          dispatch(
            showAlert({
              isOpen: true,
              title: "success",
              type: "success",
              msg: response.message,
            })
          );
        }
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_MULTIPLE_PUBLISH_SUCCESS,
          payload: {
            addMultiplePublishPending: false,
            addMultiplePublishSuccess: true,
            addMultiplePublishError: null,
          },
        });
        dispatch(resetRowTags());
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_MULTIPLE_PUBLISH_ERROR,
          payload: {
            addMultiplePublishPending: false,
            addMultiplePublishSuccess: false,
            addMultiplePublishError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function addYouTubeVideoByUrl(data, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_YOUTUBE_BY_URL_PENDING,
      payload: {
        addYoutubeByUrlPending: true,
        addYoutubeByUrlSuccess: false,
        addYoutubeByUrlError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`youtube/fetchVideoFromYoutube`, data)
      .then((response) => {
        if (response.message === "Successfully save video") {
          dispatch(
            showAlert({
              isOpen: true,
              title: "success",
              type: "success",
              msg: response.message,
            })
          );
        }
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_YOUTUBE_BY_URL_SUCCESS,
          payload: {
            addYoutubeByUrlPending: false,
            addYoutubeByUrlSuccess: true,
            addYoutubeByUrlError: null,
          },
        });
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_YOUTUBE_BY_URL_ERROR,
          payload: {
            addYoutubeByUrlPending: false,
            addYoutubeByUrlSuccess: false,
            addYoutubeByUrlError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}
